<template>
    <div class="loading-site" v-show="!hasReady">
        <div class="loader">
        </div>
    </div>
    <section class="global-product" v-show="hasReady"  :class="dataConfigSite_layout==1? '' : 'dark'">
        <div class="product">
        <section class="breadcrumbs">
            <a href="/"><span><i class="pi pi-arrow-left"></i>Voltar</span></a>
        </section>
        <section class="product-primary-content">
            <div class="info-product-primary-content">
                <h3 class="title-info-product-primary-content">{{this.dataCourse.comercialName}}</h3>
                <div class="price-info-product-primary-content">
                    <p class="normal-price-info-product-primary-content" v-show="dataCourse.discount!=0">De R${{ formatDecimals(this.dataCourse.price,2) }} por</p>
                    <p class="promo-price-info-product-primary-content">R${{ formatDecimals(this.dataCourse.price -   this.dataCourse.discount,2) }}</p>
                    <p class="installment-price-info-product-primary-content">ou 10x de R${{ formatDecimals((this.dataCourse.price -   this.dataCourse.discount)/10,2) }}</p>
                    <p class="normal-price-info-product-primary-contens" v-html="this.dataCourse.shortDescription"></p>
                </div>
                <button class="button-info-product-primary-content" @click="saveItemCart()">Comprar agora</button>
                <div class="info-course-info-product-primary-content">
                    <div class="box-info-course-info-product-primary-content">
                        <fa icon="fa-clock"></fa> Acesso Ilimitado
                    </div>
                    <div class="box-info-course-info-product-primary-content">
                        <fa icon="fa-arrow-rotate-right"></fa> 7 dias de garantia
                    </div>
                    <div class="box-info-course-info-product-primary-content">
                        <fa icon="fa-lock"></fa> Compra protegida
                    </div>
                </div>
            </div>
            <div class="banner-content" style="bac">
                <img :src="this.dataCourse.imageFinalPath2"/>
            </div>
        </section>
        <section class="detail-course">
            <div class="col-1-info-detail-course">
                <h3>Descrição do Curso</h3>
                <span v-html="this.dataCourse.longDescription"></span>
               
                <!-- <div class="video-col-1-info-detail-course">
                    <iframe width="100%" height="500" src="https://www.youtube.com/embed/F5dEqLm68CQ?si=Ov47y1zVfxZlIlBq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div> -->
                <!-- <div class="faq">
                    <h3 class="ttile-faq">Perguntas Frequentes</h3>
                    <div class="accordion faq" id="accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Como funciona o "Prazo de Garantia"?
                            </button>
                          </h2>
                          <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Nec integer quisque libero proin maecenas neque. Erat quam ultrices magna elementum maecenas. Sit sit vitae magna quam. Pretium pellentesque mi felis praesent. Pretium elit ullamcorper scelerisque nullam rhoncus vestibulum augue. In tempor id aliquam sit in a sit.                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                O que é e como funciona o Certificado de Conclusão digital?
                            </button>
                          </h2>
                          <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Nec integer quisque libero proin maecenas neque. Erat quam ultrices magna elementum maecenas. Sit sit vitae magna quam. Pretium pellentesque mi felis praesent. Pretium elit ullamcorper scelerisque nullam rhoncus vestibulum augue. In tempor id aliquam sit in a sit.                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                              Accordion Item #3
                            </button>
                          </h2>
                          <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Nec integer quisque libero proin maecenas neque. Erat quam ultrices magna elementum maecenas. Sit sit vitae magna quam. Pretium pellentesque mi felis praesent. Pretium elit ullamcorper scelerisque nullam rhoncus vestibulum augue. In tempor id aliquam sit in a sit.                            </div>
                          </div>
                        </div>
                    </div>
                </div> -->
                <div class="related desktop">
                    <h3 class="ttile-related">Produtos que talvez te interesse </h3>
                    <div class="products-related">
                        <Carousel :items-to-show="3" :wrap-around="true">
                            <Slide v-for="course, index in dataCourses" :key="index">
                            <a href="#" @click="setCouseUrl(course.url)">
                              <div class="carousel__item">
                                <img :src="course.imageFinalPath2"/>
                                <p>{{course.comercialName}}</p>
                              </div>
                            </a>
                            </Slide>
                            <template #addons>
                              <Navigation />
                            </template>
                          </Carousel>
                    </div>
                </div>
                <div class="related mobile">
                    <h3 class="ttile-related">Produtos que talvez te interesse </h3>
                    <div class="products-related">
                        <Carousel :items-to-show="1.5" :wrap-around="false">
                            <Slide v-for="course, index in dataCourses" :key="index">
                            <a href="#" @click="setCouseUrl(course.url)">
                              <div class="carousel__item">
                                <img :src="course.imageFinalPath2"/>

                                <p>{{course.comercialName}}</p>
                              </div>
                            </a>
                            </Slide>
                            <template #addons>
                              <Navigation />
                            </template>
                          </Carousel>
                    </div>
                </div>
            </div>
            <div class="col-2-course-info">
                <div class="box-course-info">
                    <div class="price-box-course-info">
                        <p class="normal-price-box-course-info" v-show="dataCourse.discount!=0">De <span>R${{ formatDecimals(this.dataCourse.price, 2) }}</span> por</p>
                        <p class="promo-price-box-course-info">R${{ formatDecimals(this.dataCourse.price -   this.dataCourse.discount,2) }}</p>
                        <p class="installment-price-box-course-info">ou 10x de R${{ formatDecimals((this.dataCourse.price -   this.dataCourse.discount)/10,2) }}</p>
                        <button class="button-price-box-course-info" @click="saveItemCart()">Comprar agora</button>
                        <div class="list-price-box-course-info">
                            <ul>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99905 16.3499C13.0583 16.3499 16.349 13.0592 16.349 8.9999C16.349 4.94061 13.0583 1.6499 8.99905 1.6499C4.93975 1.6499 1.64905 4.94061 1.64905 8.9999C1.64905 13.0592 4.93975 16.3499 8.99905 16.3499ZM14.999 8.9999C14.999 12.3136 12.3128 14.9999 8.99905 14.9999C5.68534 14.9999 2.99905 12.3136 2.99905 8.9999C2.99905 5.68619 5.68534 2.9999 8.99905 2.9999C12.3128 2.9999 14.999 5.68619 14.999 8.9999ZM9.67502 5.2499C9.67502 4.87711 9.37282 4.5749 9.00002 4.5749C8.62723 4.5749 8.32502 4.87711 8.32502 5.2499V8.68923C8.32502 9.06715 8.47515 9.42961 8.74239 9.69685L10.0227 10.9772C10.2863 11.2408 10.7137 11.2408 10.9773 10.9772C11.2409 10.7136 11.2409 10.2862 10.9773 10.0226L9.69699 8.74226C9.68293 8.72819 9.67502 8.70912 9.67502 8.68923V5.2499Z" fill="#8C8C8C"></path>
                                    </svg> 18h de conteúdo
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8842 2.66514C10.0472 1.21416 7.95307 1.21416 7.1161 2.66514L7.00201 2.86294C6.81531 3.18659 6.43441 3.34436 6.07354 3.24752L5.85299 3.18833C4.23517 2.75417 2.75441 4.23493 3.18858 5.85275L3.24776 6.0733C3.34461 6.43416 3.18683 6.81507 2.86318 7.00176L2.66538 7.11586C1.21441 7.95283 1.2144 10.0469 2.66538 10.8839L2.86318 10.998C3.18683 11.1847 3.34461 11.5656 3.24776 11.9265L3.18858 12.147C2.75441 13.7648 4.23517 15.2456 5.85299 14.8114L6.07354 14.7523C6.43441 14.6554 6.81531 14.8132 7.00201 15.1368L7.1161 15.3346C7.95307 16.7856 10.0472 16.7856 10.8842 15.3346L10.9983 15.1368C11.1849 14.8132 11.5659 14.6554 11.9267 14.7523L12.1473 14.8114C13.7651 15.2456 15.2459 13.7648 14.8117 12.147L14.7525 11.9265C14.6557 11.5656 14.8134 11.1847 15.1371 10.998L15.3349 10.8839C16.7859 10.0469 16.7859 7.95283 15.3349 7.11586L15.1371 7.00176C14.8134 6.81507 14.6557 6.43416 14.7525 6.0733L14.8117 5.85275C15.2459 4.23493 13.7651 2.75417 12.1473 3.18833L11.9267 3.24752C11.5659 3.34436 11.1849 3.18659 10.9983 2.86294L10.8842 2.66514ZM8.2855 3.33968C8.60297 2.78931 9.39729 2.78931 9.71476 3.33968L9.82886 3.53748C10.3211 4.39075 11.3253 4.8067 12.2766 4.55138L12.4972 4.4922C13.1108 4.32751 13.6725 4.88918 13.5078 5.50284L13.4486 5.72338C13.1933 6.67477 13.6093 7.67897 14.4625 8.17116L14.6603 8.28526C15.2107 8.60273 15.2107 9.39705 14.6603 9.71452L14.4625 9.82862C13.6093 10.3208 13.1933 11.325 13.4486 12.2764L13.5078 12.4969C13.6725 13.1106 13.1108 13.6723 12.4972 13.5076L12.2766 13.4484C11.3253 13.1931 10.3211 13.609 9.82886 14.4623L9.71476 14.6601C9.39729 15.2105 8.60297 15.2105 8.2855 14.6601L8.1714 14.4623C7.67921 13.609 6.67501 13.1931 5.72363 13.4484L5.50308 13.5076C4.88943 13.6723 4.32776 13.1106 4.49244 12.4969L4.55163 12.2764C4.80695 11.325 4.39099 10.3208 3.53773 9.82862L3.33993 9.71452C2.78956 9.39705 2.78956 8.60273 3.33993 8.28526L3.53773 8.17116C4.39099 7.67897 4.80695 6.67476 4.55163 5.72338L4.49244 5.50284C4.32776 4.88918 4.88943 4.32751 5.50308 4.4922L5.72363 4.55138C6.67501 4.8067 7.67921 4.39075 8.1714 3.53748L8.2855 3.33968ZM11.9774 8.47723C12.241 8.21362 12.241 7.78624 11.9774 7.52263C11.7138 7.25903 11.2864 7.25903 11.0228 7.52263L8.00013 10.5453L6.47743 9.02263C6.21382 8.75903 5.78644 8.75903 5.52283 9.02263C5.25923 9.28624 5.25923 9.71362 5.52283 9.97723L7.52283 11.9772C7.78644 12.2408 8.21382 12.2408 8.47743 11.9772L11.9774 8.47723Z" fill="#8C8C8C"></path>
                                    </svg> 7 dias de garantia
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.67518 5.49995C6.67518 4.8931 6.88609 4.46821 7.22902 4.18243C7.58774 3.8835 8.16692 3.67495 9.00019 3.67495C9.83345 3.67495 10.4126 3.8835 10.7713 4.18243C11.1143 4.46821 11.3252 4.8931 11.3252 5.49995V5.50458V5.5092V5.51381V5.51842V5.52303V5.52763V5.53222V5.53681V5.5414V5.54597V5.55055V5.55512V5.55968V5.56424V5.5688V5.57335V5.57789V5.58243V5.58696V5.59149V5.59602V5.60054V5.60505V5.60956V5.61406V5.61856V5.62305V5.62754V5.63203V5.63651V5.64098V5.64545V5.64991V5.65437V5.65883V5.66327V5.66772V5.67216V5.67659V5.68102V5.68544V5.68986V5.69428V5.69868V5.70309V5.70749V5.71188V5.71627V5.72065V5.72503V5.72941V5.73378V5.73814V5.7425V5.74685V5.7512V5.75555V5.75989V5.76422V5.76855V5.77287V5.77719V5.78151V5.78582V5.79012V5.79442V5.79872V5.80301V5.80729V5.81157V5.81584V5.82011V5.82438V5.82864V5.8329V5.83715V5.84139V5.84563V5.84987V5.8541V5.85832V5.86254V5.86676V5.87097V5.87518V5.87938V5.88358V5.88777V5.89195V5.89614V5.90031V5.90448V5.90865V5.91281V5.91697V5.92112V5.92527V5.92941V5.93355V5.93768V5.94181V5.94594V5.95005V5.95417V5.95828V5.96238V5.96648V5.97057V5.97466V5.97875V5.98282V5.9869V5.99097V5.99503V5.99909V6.00315V6.0072V6.01125V6.01529V6.01932V6.02335V6.02738V6.0314V6.03542V6.03943V6.04344V6.04744V6.05144V6.05543V6.05942V6.0634V6.06738V6.07135V6.07532V6.07928V6.08324V6.0872V6.09115V6.09509V6.09903V6.10297V6.1069V6.11082V6.11474V6.11866V6.12257V6.12648V6.13038V6.13427V6.13817V6.14205V6.14594V6.14981V6.15369V6.15756V6.16142V6.16528V6.16913V6.17298V6.17683V6.18067V6.1845V6.18833V6.19216V6.19598V6.19979V6.2036V6.20741V6.21121V6.21501V6.2188V6.22259V6.22637V6.23015V6.23393V6.2377V6.24146V6.24522V6.24897V6.25272V6.25647V6.26021V6.26395V6.26768V6.2714V6.27513V6.27884V6.28256V6.28626V6.28997V6.29367V6.29736V6.30105V6.30473V6.30841V6.31209V6.31576V6.31942V6.32309V6.32674V6.33039V6.33404V6.33768V6.34132V6.34495V6.34858V6.35221V6.35583V6.35944V6.36305V6.36666V6.37026V6.37385V6.37744V6.38103V6.38461V6.38819V6.39176V6.39533V6.3989V6.40246V6.40601V6.40956V6.41311V6.41665V6.42018V6.42371V6.42724V6.43076V6.43428V6.43779V6.4413V6.44481V6.4483V6.4518V6.45529V6.45878V6.46226V6.46573V6.4692V6.47267V6.47613V6.47959V6.48305V6.48649V6.48994V6.49338V6.49681V6.50024V6.50367V6.50709V6.51051V6.51392V6.51733V6.52073V6.52413V6.52753V6.53092V6.5343V6.53768V6.54106V6.54443V6.5478V6.55116V6.55452V6.55787V6.56122V6.56456V6.5679V6.57124V6.57457V6.5779V6.58122V6.58454V6.58785V6.59116V6.59446V6.59776V6.60106V6.60435V6.60763V6.61091V6.61419V6.61746V6.62073V6.62399V6.62725V6.63051V6.63376V6.637V6.64024V6.64348V6.64671V6.64994V6.65316V6.65638V6.6596V6.66281V6.66601V6.66921V6.67241V6.6756V6.67879V6.68197V6.68515V6.68833V6.6915V6.69466V6.69782V6.70098V6.70413V6.70728V6.71042V6.71356V6.7167V6.71983V6.72295V6.72607V6.72919V6.7323V6.73541V6.73851V6.74161V6.74471V6.7478V6.75088V6.75397V6.75704V6.76012V6.76318V6.76625V6.76931V6.77236V6.77541V6.77846V6.7815V6.78454V6.78757V6.7906V6.79363V6.79665V6.79966V6.80267V6.80568V6.80868V6.81168V6.81468V6.81767V6.82065V6.82363V6.82661V6.82958V6.83255V6.83551V6.83847V6.84143V6.84438V6.84733V6.85027V6.85321V6.85614V6.85907V6.86199V6.86491V6.86783V6.87074V6.87365V6.87655V6.87945V6.88234V6.88523V6.88812V6.891V6.89388V6.89675V6.89962V6.90249V6.90535V6.9082V6.91105V6.9139V6.91674V6.91958V6.92242V6.92525V6.92807V6.93089V6.93371V6.93653V6.93933V6.94214V6.94494V6.94774V6.95053V6.95331V6.9561V6.95888V6.96165V6.96442V6.96719V6.96995V6.97271V6.97546V6.97821V6.98096V6.9837V6.98643V6.98917V6.9919V6.99462V6.99734V7.00006V7.00277V7.00547V7.00818V7.01088V7.01357V7.01626V7.01895V7.02163V7.02431V7.02698V7.02965V7.03231V7.03498V7.03763V7.04028V7.04293V7.04558V7.04822V7.05085V7.05348V7.05611V7.05873V7.06135V7.06397V7.06658V7.06919V7.07179V7.07439V7.07698V7.07957V7.08216V7.08474V7.08732V7.08989V7.09246V7.09503V7.09759V7.10014V7.1027V7.10524V7.10779V7.11033V7.11286V7.1154V7.11792V7.12045V7.12297V7.12548V7.128V7.1305V7.13301V7.1355V7.138V7.14049V7.14298V7.14546V7.14794V7.15041V7.15288V7.15535V7.15781V7.16027V7.16273V7.16518V7.16762V7.17006V7.1725V7.17493V7.17736V7.17979V7.18221V7.18463V7.18704V7.18945V7.19186V7.19426V7.19665V7.19905V7.20144V7.20382V7.2062V7.20858V7.21095V7.21332V7.21568V7.21805V7.2204V7.22275V7.2251V7.22745V7.22979V7.23212V7.23446V7.23679V7.23911V7.24143V7.24375V7.24606V7.24837V7.25067C11.3252 7.29107 11.2927 7.32466 11.2507 7.32495H6.74964C6.70796 7.32466 6.67518 7.29112 6.67518 7.25039L6.67518 5.49995ZM5.3271 7.32495C5.32583 7.30026 5.32518 7.2754 5.32518 7.25039L5.32518 5.49995C5.32519 4.54394 5.67657 3.71884 6.36477 3.14533C7.0372 2.58497 7.95802 2.32495 9.00019 2.32495C10.0424 2.32495 10.9632 2.58497 11.6356 3.14533C12.3238 3.71884 12.6752 4.54394 12.6752 5.49995V5.50458V5.5092V5.51381V5.51842V5.52303V5.52763V5.53222V5.53681V5.5414V5.54597V5.55055V5.55512V5.55968V5.56424V5.5688V5.57335V5.57789V5.58243V5.58696V5.59149V5.59602V5.60054V5.60505V5.60956V5.61406V5.61856V5.62305V5.62754V5.63203V5.63651V5.64098V5.64545V5.64991V5.65437V5.65883V5.66327V5.66772V5.67216V5.67659V5.68102V5.68544V5.68986V5.69428V5.69868V5.70309V5.70749V5.71188V5.71627V5.72065V5.72503V5.72941V5.73378V5.73814V5.7425V5.74685V5.7512V5.75555V5.75989V5.76422V5.76855V5.77287V5.77719V5.78151V5.78582V5.79012V5.79442V5.79872V5.80301V5.80729V5.81157V5.81584V5.82011V5.82438V5.82864V5.8329V5.83715V5.84139V5.84563V5.84987V5.8541V5.85832V5.86254V5.86676V5.87097V5.87518V5.87938V5.88358V5.88777V5.89195V5.89614V5.90031V5.90448V5.90865V5.91281V5.91697V5.92112V5.92527V5.92941V5.93355V5.93768V5.94181V5.94594V5.95005V5.95417V5.95828V5.96238V5.96648V5.97057V5.97466V5.97875V5.98282V5.9869V5.99097V5.99503V5.99909V6.00315V6.0072V6.01125V6.01529V6.01932V6.02335V6.02738V6.0314V6.03542V6.03943V6.04344V6.04744V6.05144V6.05543V6.05942V6.0634V6.06738V6.07135V6.07532V6.07928V6.08324V6.0872V6.09115V6.09509V6.09903V6.10297V6.1069V6.11082V6.11474V6.11866V6.12257V6.12648V6.13038V6.13427V6.13817V6.14205V6.14594V6.14981V6.15369V6.15756V6.16142V6.16528V6.16913V6.17298V6.17683V6.18067V6.1845V6.18833V6.19216V6.19598V6.19979V6.2036V6.20741V6.21121V6.21501V6.2188V6.22259V6.22637V6.23015V6.23393V6.2377V6.24146V6.24522V6.24897V6.25272V6.25647V6.26021V6.26395V6.26768V6.2714V6.27513V6.27884V6.28256V6.28626V6.28997V6.29367V6.29736V6.30105V6.30473V6.30841V6.31209V6.31576V6.31942V6.32309V6.32674V6.33039V6.33404V6.33768V6.34132V6.34495V6.34858V6.35221V6.35583V6.35944V6.36305V6.36666V6.37026V6.37385V6.37744V6.38103V6.38461V6.38819V6.39176V6.39533V6.3989V6.40246V6.40601V6.40956V6.41311V6.41665V6.42018V6.42371V6.42724V6.43076V6.43428V6.43779V6.4413V6.44481V6.4483V6.4518V6.45529V6.45878V6.46226V6.46573V6.4692V6.47267V6.47613V6.47959V6.48305V6.48649V6.48994V6.49338V6.49681V6.50024V6.50367V6.50709V6.51051V6.51392V6.51733V6.52073V6.52413V6.52753V6.53092V6.5343V6.53768V6.54106V6.54443V6.5478V6.55116V6.55452V6.55787V6.56122V6.56456V6.5679V6.57124V6.57457V6.5779V6.58122V6.58454V6.58785V6.59116V6.59446V6.59776V6.60106V6.60435V6.60763V6.61091V6.61419V6.61746V6.62073V6.62399V6.62725V6.63051V6.63376V6.637V6.64024V6.64348V6.64671V6.64994V6.65316V6.65638V6.6596V6.66281V6.66601V6.66921V6.67241V6.6756V6.67879V6.68197V6.68515V6.68833V6.6915V6.69466V6.69782V6.70098V6.70413V6.70728V6.71042V6.71356V6.7167V6.71983V6.72295V6.72607V6.72919V6.7323V6.73541V6.73851V6.74161V6.74471V6.7478V6.75088V6.75397V6.75704V6.76012V6.76318V6.76625V6.76931V6.77236V6.77541V6.77846V6.7815V6.78454V6.78757V6.7906V6.79363V6.79665V6.79966V6.80267V6.80568V6.80868V6.81168V6.81468V6.81767V6.82065V6.82363V6.82661V6.82958V6.83255V6.83551V6.83847V6.84143V6.84438V6.84733V6.85027V6.85321V6.85614V6.85907V6.86199V6.86491V6.86783V6.87074V6.87365V6.87655V6.87945V6.88234V6.88523V6.88812V6.891V6.89388V6.89675V6.89962V6.90249V6.90535V6.9082V6.91105V6.9139V6.91674V6.91958V6.92242V6.92525V6.92807V6.93089V6.93371V6.93653V6.93933V6.94214V6.94494V6.94774V6.95053V6.95331V6.9561V6.95888V6.96165V6.96442V6.96719V6.96995V6.97271V6.97546V6.97821V6.98096V6.9837V6.98643V6.98917V6.9919V6.99462V6.99734V7.00006V7.00277V7.00547V7.00818V7.01088V7.01357V7.01626V7.01895V7.02163V7.02431V7.02698V7.02965V7.03231V7.03498V7.03763V7.04028V7.04293V7.04558V7.04822V7.05085V7.05348V7.05611V7.05873V7.06135V7.06397V7.06658V7.06919V7.07179V7.07439V7.07698V7.07957V7.08216V7.08474V7.08732V7.08989V7.09246V7.09503V7.09759V7.10014V7.1027V7.10524V7.10779V7.11033V7.11286V7.1154V7.11792V7.12045V7.12297V7.12548V7.128V7.1305V7.13301V7.1355V7.138V7.14049V7.14298V7.14546V7.14794V7.15041V7.15288V7.15535V7.15781V7.16027V7.16273V7.16518V7.16762V7.17006V7.1725V7.17493V7.17736V7.17979V7.18221V7.18463V7.18704V7.18945V7.19186V7.19426V7.19665V7.19905V7.20144V7.20382V7.2062V7.20858V7.21095V7.21332V7.21568V7.21805V7.2204V7.22275V7.2251V7.22745V7.22979V7.23212V7.23446V7.23679V7.23911V7.24143V7.24375V7.24606V7.24837V7.25067C12.6752 7.27559 12.6745 7.30035 12.6733 7.32495H13.5004C14.7016 7.32495 15.6754 8.29873 15.6754 9.49995V14.4999C15.6754 15.7012 14.7016 16.6749 13.5004 16.6749H4.50038C3.29916 16.6749 2.32538 15.7012 2.32538 14.4999V9.49995C2.32538 8.29873 3.29916 7.32495 4.50038 7.32495H5.3271ZM6.74814 8.67495H4.50038C4.04474 8.67495 3.67538 9.04431 3.67538 9.49995V14.4999C3.67538 14.9556 4.04474 15.3249 4.50038 15.3249H13.5004C13.956 15.3249 14.3254 14.9556 14.3254 14.4999V9.49995C14.3254 9.04431 13.956 8.67495 13.5004 8.67495H11.2522C11.2515 8.67495 11.2509 8.67495 11.2502 8.67495H6.75018C6.7495 8.67495 6.74882 8.67495 6.74814 8.67495Z" fill="#8C8C8C"></path>
                                    </svg> Compra protegida
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path d="M9.5 0C9.06367 0 8.62735 0.147445 8.25535 0.411183L7.0946 1.2114L5.76324 1.38446H5.74227L5.71989 1.40522C5.2821 1.50279 4.88127 1.72138 4.56402 2.03557C4.24676 2.34976 4.02612 2.74665 3.92773 3.18009L3.90675 3.20086V3.22301L3.73194 4.56455L2.92362 5.60289L2.90124 5.62366V5.64581C2.41317 6.41972 2.39079 7.41791 2.92362 8.15514L3.75222 9.30354L3.97178 10.4928L1.72022 13.8896L1 14.9487H4.34308L5.15141 16.8094L5.65486 18L6.37508 16.918L8.58329 13.63C9.17485 13.8722 9.84613 13.893 10.4181 13.63L12.6256 16.918L13.3458 17.9979L13.8493 16.8073L14.6569 14.948H18L17.2798 13.8875L15.0939 10.6001L15.2688 9.30216L16.0771 8.15583L16.0995 8.13506V8.1143C16.5875 7.339 16.6099 6.36434 16.0771 5.62574L15.2688 4.47871L15.0065 3.18009H15.0275C15.0275 3.16279 15.0086 3.15241 15.0065 3.13648C14.8807 2.23174 14.1556 1.4959 13.2375 1.38515H13.2151L11.904 1.21209L10.7454 0.411876C10.3837 0.149523 9.94832 0.00552804 9.5 0ZM9.5 1.40522C9.66083 1.40522 9.82025 1.45368 9.93703 1.53675L11.1817 2.4228L11.3355 2.53079L11.5103 2.55294L13.0403 2.76891H13.0612C13.3745 2.80352 13.5955 3.02157 13.6297 3.33169V3.37461L13.9143 4.91136L13.9353 5.06157L14.0451 5.19171L14.9401 6.42387C15.1079 6.65577 15.1289 7.04273 14.9191 7.37638L14.0451 8.58778L13.936 8.74007L13.9136 8.91313L13.6955 10.4263V10.4471C13.6846 10.5555 13.6471 10.6595 13.5864 10.7503L13.5423 10.7724V10.7946C13.4381 10.9177 13.2892 10.9953 13.1277 11.0106H13.0843L11.49 11.2923L11.3152 11.3131L11.1824 11.4218L9.93773 12.3078C9.70488 12.4739 9.29163 12.4947 8.95459 12.287L7.81762 11.4218L7.68616 11.3138L7.49038 11.2916L5.95973 11.0756H5.93736C5.8384 11.0676 5.74292 11.0358 5.6592 10.983C5.57548 10.9302 5.50606 10.8579 5.45698 10.7724C5.41009 10.6927 5.38011 10.6044 5.36887 10.5129V10.4699L5.08498 8.89167L5.0626 8.71861L4.95352 8.58709L4.05849 7.35492C3.89067 7.12441 3.86969 6.7153 4.07947 6.38165L4.95352 5.25609L5.0626 5.12595L5.08358 4.93212L5.28147 3.48191C5.28286 3.47221 5.29965 3.47152 5.30244 3.46114C5.3463 3.29463 5.43422 3.14271 5.55713 3.02104C5.68003 2.89936 5.83349 2.81233 6.00169 2.76891C6.01218 2.76614 6.01287 2.74953 6.02266 2.74814L7.48758 2.55294L7.66239 2.53079L7.81622 2.4228L9.06087 1.53675C9.17765 1.45368 9.33778 1.40522 9.4979 1.40522H9.5ZM14.329 11.9409L15.4002 13.5635H13.7164L13.5416 13.9962L13.0619 15.0989L11.5761 12.8491L11.9033 12.611L13.2794 12.3722V12.393C13.2969 12.393 13.3074 12.3743 13.3235 12.3722C13.6912 12.3194 14.0379 12.17 14.3276 11.9395L14.329 11.9409ZM4.67103 11.9617C4.9696 12.2261 5.3472 12.4103 5.76324 12.4601H5.78422L7.11838 12.6332L7.42395 12.8713L5.93875 15.0989L5.45837 13.9962L5.28356 13.5628H3.59839L4.66963 11.9617H4.67103Z" fill="#8C8C8C"></path>
                                    </svg> Certificado de conclusão
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="footer">
            <div class="logo-footer">
                <img v-show="dataConfigSite.typeLayout==1" src="../../../assets/logo.png"/>
                <img v-show="dataConfigSite.typeLayout==2" src="../../../assets/logo_white.png"/>
            </div>
            <p class="copyright-footer">@Copyright - Weeeduc | 2024 Todos os direitos reservados</p>
        </section>
        </div>
    </section>
</template>
<script>
import { Carousel, Navigation, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import { mapState, mapActions } from 'vuex';
import api from '@/utils/website';


export default{
    data(){
        return{
            dataConfigSite:[],
            dataConfigSite_layout:1,
            dataCourse:[],
            dataCourses:[],
            hasReady:false,
        }   
    }, 
    computed: {
        ...mapState(['courseWebsite','dataWebsite','courseWebsite'])
    },
    methods: {
        ...mapActions(['storeCourseWebsite','storeCourseCart']),
        async getDataSite(){
            const site = this.getCurrentUrlWithoutTrailingSlashWebsite();
            // const site = {url:'https://cursoexemplo1.weeduc.com.br'}
            try {
                const response = await api.getDataWebsite(site);
                this.dataConfigSite = response; 
                this.dataConfigSite_layout = response.typeLayout; 

                const styleElement = document.createElement('style');
                styleElement.type = 'text/css';
                styleElement.appendChild(document.createTextNode(response.css));
                document.head.appendChild(styleElement);
        
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.appendChild(document.createTextNode(response.javascript));
                document.body.appendChild(scriptElement);
                    
            } catch (error) {
                console.error('Erro ao gerar dados do site');
            }
        },
        async getCourseWebsite(){
            const site = this.getCurrentUrlWithoutTrailingSlash();
            try {
                const response = await api.getDataCourseWebsite(site);
                this.hasReady = true;
                this.dataCourse = response;
                this.loadDataProductTagManager();
            } catch (error) {
                console.error(error);
            }
        },
        async getCourses(){
            // const site = {url:'https://cursoexemplo1.weeduc.com.br'}
            const site = this.getCurrentUrlWithoutTrailingSlashWebsite();

            try {
                
                const response = await api.getDataCourse(site);
                this.dataCourses = response;
            } catch (error) {
                console.error(error);
            }
        },
        setCouseUrl(course){
            this.hasReady = false
            this.storeCourseWebsite({courseWebsite:course});
            setTimeout(() => {
                window.location.reload();
            }, 500);
        },
        formatDecimals(value, decimals) {
            if (isNaN(value)) {
                return "Invalid number";
            }
            return Number(value).toLocaleString('pt-BR', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            });
        },
        saveItemCart(){
            this.storeCourseCart({courseCart:this.dataCourse});
            this.$router.push('/checkout');
        },

        //Tag Manager
        loadDataTagManager(){
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer',this.dataWebsite.tagManagerCode);

        },

        //Tag Manager Product
        loadDataProductTagManager(){
            console.debug(this.dataCourse)
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                items: [{
                    'item_name': this.dataCourse.comercialName,
                    'item_id': this.dataCourse.id,
                    'price': this.dataCourse.price,
                    'quantity': 1
                }]
                }
            });
            console.debug(dataLayer)
        },

        //Google Analytics
        addGtagScript() {
            const script = document.createElement('script');
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id="+this.dataWebsite.googleAnalyticsCode;
            document.head.appendChild(script);
        },
        initGtag() {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', this.dataWebsite.googleAnalyticsCode);
        },

        //Facebook Pixel
        loadDataFacebbokPixel(){
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', this.dataWebsite.facebookPixelCode); 
            fbq('track', 'PageView');
        },
        //Google Ads Pixel
        addGadsScript() {
            const script = document.createElement('script');
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id="+this.dataWebsite.googleAdsCode;
            document.head.appendChild(script);
        },
        initGads() {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', this.dataWebsite.googleAdsCode);
        },
        getCurrentUrlWithoutTrailingSlash(){
            let url = 'https://homolog.weeduc.com.br'
            if( window.location.origin.includes('localhost:8080')){
                url = window.location.pathname.split('/produto/')[1]
            } else {
                url = window.location.pathname.split('/produto/')[1]
            }
            return { 'url': url}
        },
        getCurrentUrlWithoutTrailingSlashWebsite(){
            let url = 'https://homolog.weeduc.com.br'
            if( window.location.origin.includes('localhost:8080')){
                url = 'https://homolog.weeduc.com.br'
            } else {
                url = window.location.pathname.split('/produto')[0]
            }
            return { 'url': url}
        }
    },
    mounted(){
        if(this.courseWebsite==null){
        this.$router.push({ name: 'Site' });
    } else {
        this.loadDataTagManager();
        this.addGtagScript();
        this.initGtag();
        this.loadDataFacebbokPixel();
        this.addGadsScript();
        this.initGads();
    }    
       
    },
    created(){
        this.getCourseWebsite();
        this.getCourses();
        this.getDataSite();
    },
    components: {
        Carousel,
        Slide,
        Navigation,
    },
}

</script>
<style>
@import url('./product.css');
section.footer {
    position: absolute;
    left: 0;
    width: 100%;
}
.product {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 58px;
}
li.carousel__slide.carousel__slide--visible a {
    text-decoration: none;
}
.carousel__item {
    text-align: left;
}
section.global-product.dark {
    background-color: #1d1d21;
}
section.global-product.dark  section.product-primary-content {
    background-color: #181923;
    border: 1px solid #717171;
    margin-bottom: 42px;
    overflow: hidden;
}
section.global-product.dark p.installment-price-info-product-primary-content, section.global-product.dark h3.title-info-product-primary-content, section.global-product.dark p.normal-price-info-product-primary-content, section.global-product.dark p.promo-price-info-product-primary-content
{
    color: white;
}
section.global-product.dark button.button-info-product-primary-content {
    background-color: #cb2d2d;
}
section.global-product.dark .box-info-course-info-product-primary-content {
    color: white;
}
section.global-product.dark section.global-product.dark{
    color: white;
}
section.global-product.dark .col-1-info-detail-course h3{
    color: white;
}
section.global-product.dark .price-box-course-info {
    background-color: #181923;
}
section.global-product.dark  p.normal-price-box-course-info, section.global-product.dark p.promo-price-box-course-info, section.global-product.dark  p.installment-price-box-course-info,section.global-product.dark .list-price-box-course-info li{
    color: white;
}
section.global-product.dark  path {
    fill: white;
}
section.global-product.dark button.button-price-box-course-info {
    background-color: #cb2d2c;
}
section.global-product.dark .col-1-info-detail-course p{
    color: white;
}
section.global-product.dark svg.carousel__icon path {
    fill: #cb2d2c;
}
section.global-product.dark section.footer {
    background-color: #181923;
    border: none;
    border-top: 1px solid #717171;
}
section.global-product.dark p.copyright-footer {
    color: white;
}
section.global-product.dark section.breadcrumbs a{
    color: white;
}
.related.mobile{
    display: none;
}
.box-info-course-info-product-primary-content {
    display: flex;
    align-items: end;
}
section.global-product.dark .col-1-info-detail-course > span {
    color: white;
}

.col-1-info-detail-course > span {
    color: rgb(0, 0, 0);
}

@media only screen and (max-width:600px){
    section.product-primary-content {
        display: block;
    }
    .info-product-primary-content {
        width: 100%;
    }
    .banner-content{
        display: none;
    }
    section.global-product {
        padding: 20px;
    }
    section.detail-course {
        display: block;
    }
    .col-1-info-detail-course {
        width: 100%;
    }
    .col-2-course-info {
        display: none;
    }
    .related.desktop{
        display: none;
    }
    .related.mobile{
        display: block;
    }
    button.button-info-product-primary-content {
        width: 100% !important;
    }
}
.carousel__item img {
    width: 100%;
}
</style>